if (!customElements.get('bundle-picker')) {
  customElements.define(
    'bundle-picker',
    class BundlePicker extends HTMLElement {
      connectedCallback() {
        this.quantityInput = document.getElementById(this.dataset.quantityInputId);
        this.addEventListener('change', this.onChange.bind(this));
      }

      onChange(event) {
        const radio = event.target.closest('.bundle-picker__input');
        if (!radio || !this.quantityInput) return;

        this.quantityInput.value = radio.value;
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));

        const label = radio.closest('.bundle-picker__option')?.querySelector('.bundle-picker__title')?.textContent?.trim();
        const hasFreebies = radio.value !== '1';
        const savePercent = radio.dataset.savePercent ? Number(radio.dataset.savePercent) : 0;
        this.dispatchEvent(
          new CustomEvent('bundle-picker:select', {
            bubbles: true,
            detail: { quantity: radio.value, label, hasFreebies, savePercent },
          })
        );
      }
    }
  );
}
